import { cn, Toggle } from '@src/components/ui';
// Modal + ConfirmDialog now live in their proper shared home (audit d31ac04b);
// re-exported below so the many existing `./controls` import sites are unchanged.
import { ConfirmDialog, Modal } from '@src/components/ui/dialogs';


/**
 * Settings switch. Interactive switches use the shared `Toggle` primitive (T8);
 * the read-only variant (e.g. a disabled-channel row for non-managers) renders a
 * static pill since `Toggle` is always interactive. Keeps the original
 * `checked` / `onChange()` / `readOnly` / `label` API so callers are unchanged.
 */
function Switch({ checked, onChange, disabled, readOnly, label }) {
  if (readOnly) {
    return (
      <span
        aria-label={label}
        aria-checked={checked}
        className={cn(
          'inline-flex h-[26px] w-11 shrink-0 items-center rounded-full p-[3px]',
          checked ? 'justify-end bg-primary' : 'justify-start bg-hairline-strong',
        )}
        role="img"
      >
        <span className="block size-5 rounded-full bg-white shadow-sm" />
      </span>
    );
  }

  return (
    <Toggle
      checked={checked}
      aria-label={label}
      disabled={disabled}
      onCheckedChange={() => onChange()}
    />
  );
}

Switch.displayName = 'Switch';


/** Pull the first human-readable error string out of a DRF error payload. */
function firstApiError(data, ...keys) {
  if (!data || typeof data !== 'object') {
    return null;
  }
  for (const key of [...keys, 'detail', 'non_field_errors']) {
    const value = data[key];
    if (Array.isArray(value) && value.length) {
      return value[0];
    }
    if (typeof value === 'string') {
      return value;
    }
  }
  return null;
}


export { ConfirmDialog, firstApiError, Modal, Switch };
